export const getPanelHeaderStyles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    marginRight: 8,
    marginBottom: 4,
  },
});
